/**
 * AUTH-OTP-SECURITY-A1 — presentation-only six-digit OTP helpers.
 * No Redux, no fetch, no orchestration.
 */

export const OTP_CODE_LENGTH = 6;

/**
 * Deterministic sanitize for typing and paste:
 * keep ASCII digits only, preserve leading zeros, cap at six.
 */
export function sanitizeOtpCodeInput(value) {
  const digits = String(value ?? "").replace(/\D/g, "");
  return digits.slice(0, OTP_CODE_LENGTH);
}

export function isCompleteOtpCode(value) {
  return (
    typeof value === "string" &&
    value.length === OTP_CODE_LENGTH &&
    /^\d{6}$/.test(value)
  );
}
